import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { listSuppliers } from '../services/suppliersService';
import { formatDate, formatMoney } from '../lib/format';
import { friendlyError } from '../lib/errors';
import DataTable from '../components/ui/DataTable';
import SearchInput from '../components/ui/SearchInput';
import LoadingState from '../components/ui/LoadingState';
import ErrorState from '../components/ui/ErrorState';
import EmptyState from '../components/ui/EmptyState';
import { Link } from 'react-router-dom';

export default function SuppliersPage() {
  const { ruc } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');

  const fetchList = useCallback(async () => {
    if (!ruc) return;
    setLoading(true);
    setError(null);
    try {
      const result = await listSuppliers({ ruc, search, pageSize: 50 });
      setItems(result.items);
    } catch (e) {
      setError(friendlyError(e));
    } finally {
      setLoading(false);
    }
  }, [ruc, search]);

  useEffect(() => {
    const t = setTimeout(fetchList, search ? 280 : 0);
    return () => clearTimeout(t);
  }, [fetchList, search]);

  const columns = [
    { key: 'proveedorRuc', label: 'RUC' },
    { key: 'proveedorRazonSocial', label: 'Razón social' },
    { key: 'comprasCount', label: 'Compras' },
    { key: 'totalCompras', label: 'Total', render: (r) => formatMoney(r.totalCompras) },
    { key: 'ultimaCompra', label: 'Última', render: (r) => formatDate(r.ultimaCompra) },
    {
      key: 'actions',
      label: 'Acciones',
      render: (r) => (
        <button
          type="button"
          className="btn btn-mini"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/admin/proveedores/${encodeURIComponent(r.proveedorRuc)}`);
          }}
        >
          Ver
        </button>
      ),
    },
  ];

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Proveedores</h1>
          <p className="muted">
            Derivados de <code>compras</code> (el core no tiene colección <code>proveedores</code>).
            Alta = registrar una compra con RUC y razón social del proveedor.
          </p>
        </div>
        <Link className="btn btn-primary" to="/admin/compras/nueva">
          Nueva compra
        </Link>
      </header>

      <div className="toolbar">
        <SearchInput value={search} onChange={setSearch} placeholder="Buscar RUC o razón social…" />
      </div>

      {loading ? (
        <LoadingState label="Cargando proveedores…" />
      ) : error ? (
        <ErrorState message={error} onRetry={fetchList} />
      ) : (
        <DataTable
          columns={columns}
          rows={items}
          keyField="key"
          onRowClick={(row) => navigate(`/admin/proveedores/${encodeURIComponent(row.proveedorRuc)}`)}
          empty={
            <EmptyState
              title="Sin proveedores"
              description="Aparecen automáticamente al registrar compras."
            />
          }
        />
      )}
    </div>
  );
}
